module.exports = __webpack_public_path__ + "img/template-1-mobile.36b624a9.svg";